import { render, staticRenderFns } from "./ApplyDiscuss.vue?vue&type=template&id=5c5b6bd7&scoped=true&"
import script from "./ApplyDiscuss.vue?vue&type=script&lang=js&"
export * from "./ApplyDiscuss.vue?vue&type=script&lang=js&"
import style0 from "./ApplyDiscuss.vue?vue&type=style&index=0&id=5c5b6bd7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5b6bd7",
  null
  
)

export default component.exports